import { forwardRef } from 'react';
import { Typography } from '../Typography';
import MuiSelect, {
  SelectProps as MuiTextFieldProps,
} from '@mui/material/Select';
import Stack from '@mui/material/Stack';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import { v4 as uuidv4 } from 'uuid';
import { defaultTheme } from '@automata/mui-theme';
import InputLabel from '@mui/material/InputLabel';

export type SelectProps = Omit<MuiTextFieldProps, 'size'> & {
  helperText?: string;
};

export const Select = forwardRef<unknown, SelectProps>(function Forwarded(
  {
    children,
    helperText,
    error,
    disabled,
    label,
    value = '',
    placeholder = 'Select an option',
    ...restProps
  },
  ref
) {
  const id = `select-${uuidv4()}`;

  return (
    <Stack>
      <InputLabel htmlFor={id}>
        <Typography
          id={id}
          variant="overline"
          color={defaultTheme.palette.text.primary}
        >
          {label}
        </Typography>
      </InputLabel>
      <FormControl>
        <MuiSelect
          ref={ref}
          labelId={id}
          size="small"
          displayEmpty
          value={value}
          defaultValue={value}
          error={error}
          disabled={disabled}
          {...restProps}
        >
          <MenuItem disabled value="">
            <Typography color={defaultTheme.palette.grey[400]}>
              {placeholder}
            </Typography>
          </MenuItem>
          {children}
        </MuiSelect>
        <FormHelperText error={error} disabled={disabled}>
          {helperText}
        </FormHelperText>
      </FormControl>
    </Stack>
  );
});
